module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Semibold.e6ef4ea3.otf";